module.exports = __webpack_public_path__ + "img/1608885500212.8ae95b49.png";